<template>
    <section>
        <div class="page">
            <div>
                <h2>Is there a possibility to create more than one account?</h2>
                <p>
                    It is not possible to create more than one account using one phone number. In other words, only
                    one ToTok
                    account can be created and verified with one number on one device. </p>
                <p>Go to <a href="https://totok.ai/faq/android/10201">Verifying your number</a> to learn more about
                    account verification.</p>

            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
